import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Table,
  Input,
  Button,
  ButtonGroup,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import ColumnFilters from "./components/ColumnFilters";
import Loader from "components/Loader";
import crossIcon from "assets/icon/cross.png";
import searchIcon from "assets/icon/search.png";
import leftArrowIcon from "assets/icon/cps-left-arrow.svg";
import rightArrowIcon from "assets/icon/cps-right-arrow.svg";
import Pagination from "components/Pagination";
import { find } from "lodash";
import Dropdown from "react-bootstrap/Dropdown";
import threedots from "assets/icon/threedots-icon.svg";
import collapse from "assets/icon/collapse-icon.svg";
import collapseclose from "assets/icon/collapse-icon-close.svg";
import download from "assets/icon/download-icon.svg";
import SortDown from "../../assets/icon/Sort_Down.svg";
import Add from "../../assets/icon/Add.svg";
import Upload from "assets/icon/Upload-Icon.svg";
import Download from "assets/icon/Download - Icon 3.svg";
import { ModuleAccess } from "utils/moduleaccess";

let keysName = [];
let columnChangedFilters = [];
let isHaveColFilter = false;
let netClaimOpt = [
  { Code: null, label: "All", id: 0 },
  { Code: "Net Claim", label: "Net Claims Only", id: 9004 },
];

const ReactStrapTable = ({
  id,
  columns,
  data,
  lastDataRow = () => [],
  fixedColumn,
  handleSort = () => "",
  loading,
  reset,
  loader,
  hasScrollArrow = true,
  onFilterCancel = () => "",
  onSearchColumnFilters = () => "",
  pageSize,
  onPageSizeChange = () => "",
  children,
  onExport,
  AllExport,
  slelectedExport,
  onSelectColoums,
  onAdd,
  hasAddPermission = true,
  isAddDisable = true,
  onNetClaimClick,
  selectedNetClaim,
  hasNetClaimDropDownPermission = false,
  hasPagination,
  onPageChange,
  currentPage,
  totalRecords,
  hasColselect = false,
  hasExportPermission1 = true,
  filters,
  autoselectlist1,
  researchNeededCount = 0,
  eligibleCount = 0,
  inEligibleCount = 0,
  hasNoEligibility = true,
  hasExportPermission = true,
  hasDisabledSelectedCols = true,
  toggleSider,
  isHaveColFilter = false,
  collapseSider,
  hasCESelected,
  enabletogglesider = false,
  gridMsg = "No record found",
  navitemlist,
  prescriber,
  toggleAddDrawer,
  toggleTemplate,
  toggleUploadDrawer,
  isHideFilter = false,
  isHideDisplayRecords = false,
  tablecolour,
}) => {

  const [key, setKey] = useState("");
  const [resetField, setResetField] = useState(false);
  const [hasVisibleScrollArrow, setVisibleScrollArrow] = useState(false);
  const [hasLeftArrow, setLeftArrow] = useState(false);
  const [hasRightArrow, setRightArrow] = useState(false);
  const [rSelected, setRSelected] = useState("off");
  const [colFilterEnable, setColFilterEnable] = useState(false);
  const [sortKey, setSortKey] = useState("desc");
  const selectRef = useRef(null);
  // (tablecolour, data.claimEligibilityID, "data", data);

  // useEffect(() => {
  //   columnChangedFilters = [];
  // }, []);

    const hasPermission = (code) => {
    return ModuleAccess("CLNTDB", code);
  }
  const getUpdateColum = () => {
    const updateCol = [];
    const col = columns[0];
    if (!col?.action && colFilterEnable) {
      updateCol.push({
        dataField: "Options",
        text: "Options",
        width: 100,
        show: false,
        disabled: true,
        hideColFilter: true,
        action: true,
      });
    }
    return [...updateCol, ...columns];
  };
  useEffect(() => {
    setKey("");
  }, [reset]);

  const removeSort = (keys) => {
    keysName.push(keys);
    const filter = keysName.filter((item) => item === keys);
    if (filter.length === 3) {
      setKey("");
      setSortKey("desc");
      keysName = [];
    } else {
      const sortObj = {
        order: sortKey === "desc" ? "asc" : "desc",
        orderBy: keys,
      };
      setSortKey(sortObj.order);
      if (isHaveColFilter) {
        const apiFilter = {
          ...filters,
          ...sortObj,
          filters: [...columnChangedFilters],
        };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys, true, columnChangedFilters);
        handleSort(apiFilter, true);
      } else {
        const apiFilter = { ...filters, ...sortObj };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys);
        handleSort(apiFilter);
      }
    }
  };
  const onColHeaderClick = (col) => {
    if (col.disabled) return;
    setKey(col.dataField);
    removeSort(col.dataField);
  };

  const headerRenderer = () => {
    const cols = getUpdateColum().map((col, index) => {
      return (
        <th
          key={col.dataField}
          className={
            key === col.dataField
              ? `active-sorting-${sortKey === "asc" ? "down" : "up"}`
              : ""
          }
          width={col.width || 100}
          onClick={() => {
            col.sort ? onColHeaderClick(col) : "";
          }}
          hidden={!col.show}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="" style={{ width: col.width - 17 }}>
              {col.text}
            </div>
            {col.sort == true && sortKey == "desc" && keysName.length == 0 ? (
              <span
                className=""
                style={{
                  // marginLeft: "8px",
                  position: "relative",
                  verticalAlign: "sub",
                  marginTop: "7px",
                }}
              >
                <img
                  src={SortDown}
                  style={{ marginLeft: "0px" }}
                  alt=""
                //  onClick={() => {
                //    col.sort ? onColHeaderClickTop(col) : '';
                // }}
                />
                <img
                  className="filters_col"
                  src={SortDown}
                  alt=""
                // onClick={() => {
                //   col.sort ? onColHeaderClickDown(col) : '';
                // }}
                />
              </span>
            ) : (
              <div style={{ width: "17px" }}></div>
            )}
          </div>
        </th>
      );
    });
    return (
      <thead key="headerrow">
        <tr>
          {/* {colFilterEnable && columns[0].action ? <th width={100}>Options</th> : ""} */}
          {cols}
          {/* {colFilterEnable && <th width={100}>Options</th>} */}
        </tr>
      </thead>
    );
  };
  // const renderRow = () => {
  //   if (data.length) {
  //     const rows = data.map((row, index) => {
  //       const rowItem = getUpdateColum().map((col) => {
  //         // if (index === 0 && colFilterEnable) {
  //         //   return <th key="option" width={100}></th>;
  //         // }
  //         if (col.cellRenderer) {
  //           return (
  //             <td
  //               portalId="root portal"
  //               key={col.dataField}
  //               width={col.width || 100}
  //               className={col.edit ? "py-1" : col.className || ""}
  //               hidden={!col.show}
  //             >
  //               {col.cellRenderer(row, col)}
  //             </td>
  //           );
  //         }
  //         return (
  //           <td key={col.dataField} width={col.width || 100} hidden={!col.show}>
  //             {row[col.dataField]}
  //           </td>
  //         );
  //       });
  //       return (
  //         <tr key={index}>
  //           {rowItem}
  //           {/* {colFilterEnable && <td width={100}></td>} */}
  //         </tr>
  //       );
  //     });
  //     return rows;
  //   } else {
  //     return (
  //       <tr>
  //         <td colSpan={getUpdateColum().length} className="text-center">
  //           {loading ? "Loading..." : gridMsg}
  //         </td>
  //       </tr>
  //     );
  //   }
  // };
  const renderRow = () => {
    if (data?.length) {
      const rows = data?.map((row, index) => {
        const rowClass = getRowClass(row.claimEligibilityID); // Get the row class based on claimEligibilityID

        const rowItem = getUpdateColum()?.map((col) => {
          if (col.cellRenderer) {
            return (
              <td
                portalId="root portal"
                key={col.dataField}
                width={col.width || 100}
                className={col.edit ? "py-1" : col.className || ""}
                hidden={!col.show}
              >
                {col.cellRenderer(row, col)}
              </td>
            );
          }

          return (
            <td key={col.dataField} width={col.width || 100} hidden={!col.show}>
              {row[col.dataField]}
            </td>
          );
        });

        return (
          <tr key={index} className={rowClass}>
            {" "}
            {rowItem}
          </tr>
        );
      });

      return rows;
    } else {
      return (
        <tr>
          <td colSpan={getUpdateColum().length} className="text-center">
            {loading ? "Loading..." : gridMsg}
          </td>
        </tr>
      );
    }
  };


  const renderFooter = (lastDataRow) => {

    if (lastDataRow.length) {
      const rows = lastDataRow.map((row, index) => {
        const rowClass = getRowClass(row.claimEligibilityID); // Get the row class based on claimEligibilityID

        const rowItem = getUpdateColum().map((col) => {
          if (col.cellRenderer) {
            return (
              <td
                portalId="root portal"
                key={col.dataField}
                width={col.width || 100}
                className={col.edit ? "py-1" : col.className || ""}
                hidden={!col.show}
              >
                {col.cellRenderer(row, col)}
              </td>
            );
          }

          return (
            <td key={col.dataField} width={col.width || 100} hidden={!col.show}>
              {row[col.dataField]}
            </td>
          );
        });

        return (
          <tr key={index} className={rowClass}>
            {" "}
            {rowItem}
          </tr>
        );
      });

      return rows;
    }
  }

  const handleColumnFilterChange = (
    { target: { value } },
    col,
    type,
    filterType
  ) => {
    const { dataField } = col;
    const obj = {
      filterName: dataField,
      filterType: filterType === "" ? 1 : parseInt(filterType),
    };
    if (!value) {
      const filter = columnChangedFilters?.filter(
        (item) => item.filterName !== dataField
      );
      columnChangedFilters = filter;
      return;
    } else if (value == "Invalid date") {
      const filter = columnChangedFilters?.filter(
        (item) => item.filterName !== dataField
      );
      columnChangedFilters = filter;
      return;
    }
    const findObj = find(columnChangedFilters, {
      filterName: dataField,
    });
    if (findObj) {
      if (type === "field") {
        findObj.filterValue = value;
      } else {
        findObj.filterType = parseInt(value);
      }
    } else {
      if (type === "field") {
        obj.filterValue = value;
      } else {
        obj.filterType = parseInt(value);
      }
      const colFilters = [...columnChangedFilters, ...[obj]].filter(
        (item) => item.filterValue
      );
      columnChangedFilters = colFilters;
    }
  };

  const onSearchFilter = () => {
    isHaveColFilter = true;
    onSearchColumnFilters(columnChangedFilters);
  };

  const onCancelFilter = () => {
    isHaveColFilter = false;
    onFilterCancel();
    setResetField((pre) => !pre);
    columnChangedFilters = [];
  };

  const columnFilters = () => {
    var ids = [];
    if (hasColselect) {
      if (autoselectlist1.length > 0)
        for (var x in autoselectlist1) {
          ids.push(autoselectlist1[x].text);
        }
    }
    return (
      <tr
        className="filter_tdfixed"
      // style={{ position: "sticky", top: "50px", zIndex: 11 }}
      >
        {getUpdateColum()?.map((col, index) => {
          if (index === 0) {
            return (
              <td key="action">
                <span className="pe-2 cursor-pointer" onClick={onSearchFilter}>
                  <img src={searchIcon} alt="" />
                </span>
                <span className="cursor-pointer" onClick={onCancelFilter}>
                  <img src={crossIcon} alt="" />
                </span>
              </td>
            );
          }
          if (col.hideColFilter && !col.show) {
            return <td hidden={true} key={col.dataField}></td>;
          } else if (col.hideColFilter) {
            return <td key={col.dataField}></td>;
          }
          return (
            <td
              key={col.dataField}
              hidden={
                hasColselect
                  ? autoselectlist1.length > 0
                    ? !ids.includes(col.text)
                    : false
                  : false
              }
            >
              <ColumnFilters
                col={col}
                onColumnFilterChange={handleColumnFilterChange}
                reset={resetField}
              />
            </td>
          );
        })}
      </tr>
    );
  };

  const getCurrentTableElement = () =>
    document
      .querySelector(`#${id}`)
      .getElementsByClassName("table-responsive")[0];

  const handleMouseEnter = () => {
    if (!id) return;
    const element = getCurrentTableElement();
    const rightScroll =
      element.scrollWidth - element.scrollLeft - element.clientWidth;
    if (rightScroll <= 10 && element.scrollLeft <= 10) return;
    if (element.scrollLeft <= 0) {
      setLeftArrow(false);
      setRightArrow(true);
    } else {
      setLeftArrow(true);
    }
    if (rightScroll <= 0) {
      setLeftArrow(true);
      setRightArrow(false);
    }
    setVisibleScrollArrow(true);
  };

  const handleMouseLeave = () => {
    setVisibleScrollArrow(false);
  };
  const getRowClass = (claimEligibilityID) => {
    switch (claimEligibilityID) {
      case 21001:
        return "table-striped1"; // CSS for ID 21001
      case 21002:
        return "table-striped2"; // CSS for ID 21002
      case 21003:
        return "table-striped3"; // CSS for ID 21003
      default:
        return "table-striped"; // Default styling
    }
  };
  const getTableClass = (data) => {
    // Check if any row's claimEligibilityID matches the special ones (21001, 21002, or 21003)
     if(data==null){
      data=[]
     }
    const hasSpecialClaimID = data.some((row) =>
      [21001, 21002, 21003].includes(row.claimEligibilityID)
    );

    // If found, return 'table-striped-audit', otherwise return 'table-striped'
    return hasSpecialClaimID ? "table-striped-audit" : "table-striped";
  };
  const scroll = (direction) => {
    const element = getCurrentTableElement();
    slideScroll(element, direction, 50, 500, 70);
  };

  const slideScroll = (element, direction, speed, distance, step) => {
    let scrollAmount = 0;
    var slideTimer = setInterval(function () {
      element.behavior = "smooth";
      if (direction == "left") {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);

    setTimeout(() => {
      const el = getCurrentTableElement();
      const rightScroll = el.scrollWidth - el.scrollLeft - el.clientWidth;
      if (el.scrollLeft === 0) {
        setLeftArrow(false);
      } else {
        setLeftArrow(true);
      }
      if (rightScroll <= 0) {
        setRightArrow(false);
      } else {
        setRightArrow(true);
      }
    }, 500);
  };

  const renderScrollArrowButtons = () => {
    if (hasScrollArrow && hasVisibleScrollArrow && data && data.length) {
      return (
        <>
          {hasLeftArrow && (
            <Button
              onClick={() => scroll("left")}
              color="link"
              className={`left-table-button ${!hasLeftArrow ? "opacity-25" : ""
                }`}
              disabled={!hasLeftArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={leftArrowIcon}
                alt="leftArrowIcon"
                height={32}
                width={32}
              />
            </Button>
          )}
          {hasRightArrow && (
            <Button
              onClick={() => scroll("right")}
              color="link"
              className={`right-table-button ${!hasRightArrow ? "opacity-25" : ""
                }`}
              disabled={!hasRightArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={rightArrowIcon}
                alt="rightArrowIcon"
                height={32}
                width={32}
              />
            </Button>
          )}
        </>
      );
    }
    return null;
  };

  const onClickFilter = (value) => {
    if (value === "on") {
      setRSelected(value);
      setColFilterEnable(true);
    } else {
      setResetField((pre) => !pre);
      setRSelected(value);
      setColFilterEnable(false);
      columnChangedFilters = [];
      // onFilterCancel();
      onCancelFilter();
    }
    columnChangedFilters = [];
  };

  const onHandlePageChange = (page) => {
    const pageFilter = { ...filters, currentPage: page };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageChange(colFilterOn, true, columnChangedFilters);
    }
    onPageChange(pageFilter);
  };

  const handlePageSizeChange = (e) => {
    const { value } = e.target;
    const pageFilter = {
      ...filters,
      currentPage: 1,
      pageSize: parseInt(value),
    };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageSizeChange(colFilterOn, true, columnChangedFilters);
    }
    onPageSizeChange(pageFilter);
  };

  return (
    <>
      {pageSize && (
        <Row className="justify-content-end align-items-center py-2">
          <Col style={{ display: "flex", alignItems: "center" }} hidden={isHideDisplayRecords}>
            <span className="text-dark f-14 font-weight-600">Display</span>
            <Input
              type="select"
              onChange={handlePageSizeChange}
              bsSize="sm"
              className="display-select d-inline-block pages_view"
              style={{ lineHeight: "20px" }}
              value={pageSize}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Input>
            <span className="text-dark f-14 d-inline-block font-weight-500">
              records
            </span>
            {hasNetClaimDropDownPermission && (
              <span
                className="text-dark"
                style={{
                  margin: "0px 10px",
                  borderLeft: "1px solid green",
                  height: "40px",
                }}
              ></span>
            )}
            {hasNetClaimDropDownPermission && (
              <Input
                id="netClaim"
                name="netClaim"
                type="select"
                className="display-select d-inline-block"
                style={{
                  width: "150px",
                  margin: "0px 40px",
                  minHeight: "30px !important",
                }}
                onChange={(val) => onNetClaimClick(val.target.value)}
                value={selectedNetClaim}
              >
                {netClaimOpt.map((option) => {
                  return (
                    <option
                      value={option.id}
                      key={`${option.id}_${option.label}`}
                    >
                      {option.label}
                    </option>
                  );
                })}
              </Input>
            )}
          </Col>
          <Col>
            {onAdd && hasAddPermission && (
              <Button
                size="sm"
                color="export"
                className="ms-auto"
                style={{ float: "right" }}
                onClick={onAdd}
                disabled={isAddDisable}
              >
                Add
              </Button>
            )}
          </Col>
          <Col xs="auto">
            {hasColselect && (
              <Button
                size="sm"
                color="primary"
                className="ms-auto"
                onClick={onSelectColoums}
                style={{ height: 35 }}
              // disabled={!data.length}
              >
                Column selector
              </Button>
            )}
            {/* <span className='ps-3 pe-2 f-13' hidden={filtercolunm}>Filter Column</span>
            <ButtonGroup className='filter-btn-group' hidden={filtercolunm}>
              <Button
                color='info'
                outline
                onClick={() => onClickFilter('off')}
                active={rSelected === 'off'}
                disabled={!data.length}
              >
                OFF
              </Button>
              <Button
                color='info'
                outline
                onClick={() => onClickFilter('on')}
                active={rSelected === 'on'}
                disabled={!data.length}
              >
                On
              </Button>
            </ButtonGroup> */}
          </Col>
          <Col xs="auto p-0">
            <div className="d-flex align-items-center ex_dropdown">
              {AllExport && hasExportPermission1 && (
                <UncontrolledDropdown group disabled={!data.length}>
                  <Button
                    size="sm"
                    color="primary"
                    className="ms-auto"
                    onClick={onExport}
                    disabled={!data.length}
                    hidden={!hasPermission('EDT')}
                  >
                    Export
                  </Button>
                  <DropdownToggle
                    className="ms-auto"
                    caret
                    color="primary"
                    size="sm"
                    outline
                    disabled={!data.length}
                  />

                  <DropdownMenu className="border-0 p-1 status-dropdown">
                    <DropdownItem onClick={AllExport}>All Columns</DropdownItem>
                    <DropdownItem
                      disabled={hasDisabledSelectedCols}
                      onClick={slelectedExport}
                    >
                      Selected Columns
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}

              {onExport && hasExportPermission && (
                <Button
                  size="sm"
                  color="export"
                  className="ms-auto"
                  onClick={onExport}
                  disabled={!data.length}
                   hidden={!hasPermission('EDT')}
                >
                  <span className="">
                    <img style={{ width: "14px" }} src={download} alt="" />
                  </span>{" "}
                  Export
                </Button>
              )}
              <span className="ps-3 pe-2 f-13 font-weight-600" hidden={isHideFilter}>Filter</span>
              <ButtonGroup className="filter-btn-group" hidden={isHideFilter}>
                <Button
                  color="info"
                  outline
                  onClick={() => onClickFilter("off")}
                  active={rSelected === "off"}
                  disabled={!data.length}
                >
                  OFF
                </Button>
                <Button
                  color="info"
                  outline
                  onClick={() => onClickFilter("on")}
                  active={rSelected === "on"}
                  disabled={!data.length}
                >
                  ON
                </Button>
              </ButtonGroup>
              {prescriber ? (
                <Dropdown className="nav_list-pre ms-2">
                  <Dropdown.Toggle variant="success" id="dropdown-basic" disabled={id == 'view-bin-table' && hasCESelected == false}>
                    <img src={threedots} alt="" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#" onClick={toggleAddDrawer}>
                      <img src={Add} alt="" className="me-1" /> Add
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={toggleTemplate}>
                      <img src={Download} alt="" className="me-1" /> Download
                      Template
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={toggleUploadDrawer}>
                      <img src={Upload} alt="" className="me-1" />
                      Upload
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                ""
              )}
            </div>
          </Col>
          {enabletogglesider && (
            <Col xs="auto p-0">
              <div
                className="togglesider ps-3 ms-3"
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col>
          )}
        </Row>
      )}
      <div
        className="rounded-table"
        ref={selectRef}
        id={id}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseEnter}
      >
        {!loader && loading && <Loader opacity={0.01} color="black" />}
        {renderScrollArrowButtons()}
        {/* {tablecolour == true ? (
          <>
            {data.map((item) => {
              return (
                <>
                  {item.claimEligibilityID == 21001 && (
                    <Table
                      responsive
                      id="reactstrap-table"
                      className={`table table-striped1 theme-table ${
                        fixedColumn && "fixed-column-table"
                      }`}
                      style={{ scrollBehavior: "smooth" }}
                    >
                      {headerRenderer()}
                      <tbody>
                        {colFilterEnable && columnFilters()}
                        {renderRow()}
                      </tbody>
                    </Table>
                  )}
                  {item.claimEligibilityID == 21002 && (
                    <Table
                      responsive
                      id="reactstrap-table"
                      className={`table table-striped2 theme-table ${
                        fixedColumn && "fixed-column-table"
                      }`}
                      style={{ scrollBehavior: "smooth" }}
                    >
                      {headerRenderer()}
                      <tbody>
                        {colFilterEnable && columnFilters()}
                        {renderRow()}
                      </tbody>
                    </Table>
                  )}
                  {item.claimEligibilityID == 21003 && (
                    <Table
                      responsive
                      id="reactstrap-table"
                      className={`table table-striped3 theme-table ${
                        fixedColumn && "fixed-column-table"
                      }`}
                      style={{ scrollBehavior: "smooth" }}
                    >
                      {headerRenderer()}
                      <tbody>
                        {colFilterEnable && columnFilters()}
                        {renderRow()}
                      </tbody>
                    </Table>
                  )}
                </>
              );
            })}
          </>
        ) : (
          <Table
            responsive
            id="reactstrap-table"
            className={`table table-striped theme-table ${
              fixedColumn && "fixed-column-table"
            }`}
            style={{ scrollBehavior: "smooth" }}
          >
            {headerRenderer()}
            <tbody>
              {colFilterEnable && columnFilters()}
              {renderRow()}
            </tbody>
          </Table>
        )} */}
        {/* {tablecolour === true ? (
          <>
            <Table
              responsive
              id="reactstrap-table"
              className={`table table-striped theme-table ${
                fixedColumn ? "fixed-column-table" : ""
              }`}
              style={{ scrollBehavior: "smooth" }}
            >
              {headerRenderer()}
              <tbody>
                {colFilterEnable && columnFilters()}

                {Array.isArray(data) && data.length > 0
                  ? data.map((item, index) => (
                      <tr
                        key={index} // Key for each row (use index or item unique id)
                        className={getRowClass(item.claimEligibilityID)} // Dynamically set class based on claimEligibilityID
                      >
                        {renderRow(item)} 
                      </tr>
                    ))
                  : ""}
              </tbody>
            </Table>
          </>
        ) : (
          <Table
            responsive
            id="reactstrap-table"
            className={`table table-striped theme-table ${
              fixedColumn ? "fixed-column-table" : ""
            }`}
            style={{ scrollBehavior: "smooth" }}
          >
            {headerRenderer()}
            <tbody>
              {colFilterEnable && columnFilters()}
              {renderRow(data)} 
            </tbody>
          </Table>
        )} */}
        <Table
          responsive
          id="reactstrap-table"
          className={`table ${getTableClass(data)} theme-table ${fixedColumn ? "fixed-column-table" : ""
            }`}
          style={{ scrollBehavior: "smooth" }}
        >
          {headerRenderer()}
          <tbody>
            {colFilterEnable && columnFilters()}
            {renderRow(data)}
          </tbody>
          <tfoot>
            {renderFooter(lastDataRow)}
          </tfoot>
        </Table>
      </div>
      {hasPagination && (
        <Pagination
          onPageChange={onHandlePageChange}
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          hasNoEligibility={hasNoEligibility}
          researchNeededCount={researchNeededCount}
          eligibleCount={eligibleCount}
          inEligibleCount={inEligibleCount}
        />
      )}
    </>
  );
};

export default ReactStrapTable;
